import {Component, inject, Inject} from '@angular/core';
import {AuthService} from '@auth0/auth0-angular';
import {AsyncPipe, DOCUMENT, NgIf} from '@angular/common';
import {ButtonVariant} from '../../shared/components/button-generator/button-generator.component';
import {ButtonGeneratorModuleModule} from '../../shared/components/button-generator/button-generator-module.module';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatMenuModule} from '@angular/material/menu';
import {TranslocoPipe} from '@jsverse/transloco';

@Component({
  selector: 'app-auth-button',
  imports: [
    AsyncPipe,
    NgIf,
    ButtonGeneratorModuleModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    TranslocoPipe,

  ],
  templateUrl: './auth-button.component.html',
  styleUrl: './auth-button.component.css',
})
export class AuthButtonComponent {
  private document = inject(DOCUMENT);

  constructor(
    public auth: AuthService,
  ) {
    this.auth.getAccessTokenSilently();
  }

  login(): void {
    this.auth.loginWithRedirect({appState: {target: '/'}});
  }

  logout(): void {
    this.auth.logout({logoutParams: {returnTo: this.document.location.origin}});
  }

  protected readonly ButtonVariant = ButtonVariant;
}
